var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 16.5,
    cy: 15.5,
    r: 2,
    stroke: "#5784F7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 6.5,
    cy: 15.5,
    r: 2,
    stroke: "#5784F7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 15.4724C3.40328 15.4178 2.7191 15.2546 2.23223 14.7678C1.74536 14.2809 1.58222 13.5967 1.52755 12.5M8.5 15.5H14.5M18.5 15.4724C19.5967 15.4178 20.2809 15.2546 20.7678 14.7678C21.5 14.0355 21.5 12.857 21.5 10.5V8.5H16.8C16.0555 8.5 15.6832 8.5 15.382 8.40211C14.7731 8.20428 14.2957 7.72691 14.0979 7.11803C14 6.81677 14 6.44451 14 5.7C14 4.58323 14 4.02485 13.8532 3.57295C13.5564 2.65964 12.8404 1.94358 11.9271 1.64683C11.4752 1.5 10.9168 1.5 9.8 1.5H1.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M1.5 5.5H7.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M1.5 8.5H5.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 3.5H15.8212C17.2766 3.5 18.0042 3.5 18.5964 3.85371C19.1886 4.20742 19.5336 4.84811 20.2236 6.1295L21.5 8.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon2);
export default __webpack_public_path__ + "static/media/LineIcon2.4a061d22698537599c6dea5223f38b5d.svg";
export { ForwardRef as ReactComponent };